<template>
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="color"
            transition="scale-transition"
            offset-y
            min-width="290px">
            <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="primaryColor"
                :label="titulo"
                readonly
                v-bind="attrs"
                :color="primaryColor"
                v-on="on">
                    <template v-slot:prepend>
                        <template>
                        <v-icon :color="primaryColor">mdi-palette</v-icon>
                        </template>
                    </template>
                </v-text-field>                                                
            </template>
            <v-card>
            <v-color-picker v-model="color" light></v-color-picker>
                <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="sendSelectData(color)">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>        
</template>
<script>
export default {
    props: ['title','mainColor'],
    data(){
        return {
            menu: false,
            color: '#1CA085',
            primaryColor: '#296B74',
            titulo: ''
        }
    },
    created(){
        this.primaryColor = this.mainColor
        this.titulo = this.title

    },
    methods: {
        sendSelectData(value) {
            this.primaryColor = value
            this.menu = false            
            this.$emit('colorSelect', value)
            // console.log('emitiu o evento')
            // console.log(this.sendedAccount)
        },       
    }
}
</script>